<form [formGroup]="createAuctionForm2" *ngIf="showView">
  <div class="row">
    <div class="col-12">
      <div class="upload-with-name">
        <div class="custom-file-upload">
          <span class="upload-inner">
            <div *ngIf="coverPhotoString != null; else showPlaceholder">
              <img alt="thumb-image" class="thumb-image" width="150" [src]="coverPhotoString" />
            </div>
            <ng-template #showPlaceholder>
              <img class="thumb-image" src="../assets/images/thumbnail-square.jpg" title="thumb-image"
                alt="thumb-image" />
            </ng-template>
            <img src="../assets/images/ic-upload-photo.svg" class="upload-btn" alt="upload-btn" role="button"
              (click)="cover.click()" />
          </span>
          <input type="file" style="display: none" [accept]="coverPhotoFormat" #cover
            (change)="uploadCoverPhoto($event.target.files)" />
        </div>
        <div class="for-info">
          <p class="name">Cover Photo</p>
          <p class="upload-note m-0">
            Recommended Size : <br class="d-sm-none" />
            1024 * 720 px <br />
            <br class="d-sm-none" />
            File size should not exceed {{ +coverPhotoSize / (1024 * 1024) }} MB
          </p>
          <control-messages [isFormSubmitted]="submitted" [control]="createAuctionForm2.controls.coverPhoto">
          </control-messages>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="upload-with-name">
        <div class="custom-file-upload">
          <span class="upload-inner">
            <div class="upload-container" *ngIf="clientLogoString != null; else showPlaceholder">
              <img alt="thumb-image" class="thumb-image" width="150" [src]="clientLogoString" />
            </div>
            <ng-template #showPlaceholder>
              <img class="thumb-image" src="../assets/images/thumbnail-square.jpg" alt="thumb-image"
                title="thumb-image" />
            </ng-template>
            <img src="../assets/images/ic-upload-photo.svg" class="upload-btn" alt="upload-btn" role="button"
              (click)="logo.click()" />
          </span>
          <input type="file" style="display: none" [accept]="clientLogoFormat" #logo
            (change)="uploadClientLogo($event.target.files)" />
        </div>
        <div class="for-info">
          <p class="name">Client Logo</p>
          <p class="upload-note m-0">
            Recommended Size : <br class="d-sm-none" />
            240 * 240 px <br />
            <br class="d-sm-none" />
            File size should not exceed {{ +clientLogoSize / (1024 * 1024) }} MB
          </p>
          <control-messages [isFormSubmitted]="submitted" [control]="createAuctionForm2.controls.clientLogo">
          </control-messages>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="max-width-600">
        <h5 class="small-label mt-4">Slider Images</h5>
        <p class="upload-note m-0 pb-2">
          Note : All slider images will appear in image gallery by default for
          front end user.
        </p>
        <p class="upload-note m-0 pb-2">
          image should be greater than 256 Pixel X 256 pixel
        </p>
        <image-uploader [auctionId]="auctionId" [imageSize]="+sliderImageSize" [imageFormat]="sliderImageFormat"
          [uploadedImages]="addEditDeleteSliderImages" [assetType]="sliderImageAsset" [assetName]="'Slider Images'"
          [resetImagesNeeded]="true" [orderChangeNeeded]="true" (resultantImages)="resultantSliderImages = $event"
          [errorLogs]="sliderErrorLogs"></image-uploader>
      </div>
    </div>
    <div class="col-12">
      <div class="max-width-600 text-center">
        <p class="or-text">Or</p>
      </div>
      <div class="max-width-600 text-center">
        <button class="btn btn-colored mb-2" role="button" (click)="openSyncSliderModal(syncPopup)">
          Sync Images
        </button>
      </div>
      <p class="upload-note m-0 pb-2">
        Note : Click "Sync Images" button to sync images placed on server.
      </p>
    </div>

    <div class="col-12">
      <div class="max-width-600">
        <p class="small-label mt-4">Photo Gallery</p>
        <p class="upload-note m-0 pb-2">
          image should be greater than 256 Pixel X 256 pixel
        </p>
        <image-uploader [auctionId]="auctionId" [imageSize]="+photoGallerySize" [imageFormat]="photoGalleryFormat"
          [assetName]="'Photo Gallery'" [assetType]="photoGalleryAsset" [uploadedImages]="addEditDeletePhotoGallery"
          [resetImagesNeeded]="true" [orderChangeNeeded]="true" (resultantImages)="resultantGalleryImages = $event"
          [errorLogs]="galleryErrorLogs"></image-uploader>
      </div>
    </div>
    <div class="col-12">
      <div class="max-width-600 text-center">
        <p class="or-text">Or</p>
      </div>
      <div class="max-width-600 text-center">
        <button class="btn btn-colored mb-2" role="button" (click)="openSyncGalleryModal(syncGalleryPopup)">
          Sync Images
        </button>
      </div>
      <p class="upload-note m-0 pb-2">
        Note : Click "Sync Images" button to sync images placed on server.
      </p>
    </div>

    <div class="col-12">
      <p class="error-msg my-2" *ngIf="createAuctionForm2.invalid && submitted">
        Please resolve error(s) first
      </p>
    </div>

    <div class="col-12">
      <div class="steps-btn-wrap pt-0 pt-md-4 mt-2">
        <button class="btn btn-white-border mr-2 half-mob" role="button" (click)="onCancel()">
          Cancel
        </button>
        <a class="btn btn-white-border mr-2 half-mob" role="button" (click)="goToStep()">Back</a>
        <button type="submit" class="btn btn-colored full-mob" role="button" (click)="save()">
          Save & Continue
        </button>
      </div>
    </div>
  </div>
</form>





<ng-template #syncPopup>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="delete-data">
      <img alt="delete-icon" src="../assets/images/delete-icon.svg" />
      <h1 class="modal-inner-hdg mt-3">
        Confirm
      </h1>
      <p class="des">
        Sync Images will overwrite the uploaded images. Are you sure you want to proceed?
      </p>
      <div class="delete-btns">
        <button type="button" class="btn btn-text mr-2" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button class="btn btn-colored pad-22" role="button" (click)="
          syncSliderImages()
          ">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #syncGalleryPopup>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="delete-data">
      <img alt="delete-icon" src="../assets/images/delete-icon.svg" />
      <h1 class="modal-inner-hdg mt-3">
        Confirm
      </h1>
      <p class="des">
        Sync Images will overwrite the uploaded images. Are you sure you want to proceed?
      </p>
      <div class="delete-btns">
        <button type="button" class="btn btn-text mr-2" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button class="btn btn-colored pad-22" role="button" (click)="
          syncGalleryImages()
          ">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>
